import {
    getInternetAccessResponse,
    getUserPackage,
    restartWarningDialogPleaseCheckYourDataUsage
} from "../store/UserStore";
import {ICON_TYPE} from "../component/base/onboard-dialog-dynamic-component/OnboardDialogDynamic";
import {
    againRequestAccessInternetPopup,
    dialogInternetAccessProblem,
    dialogMaxConcurrentSessionLimitIsReached,
    dialogScratchCardLoginFailed,
    dialogUserIdExistsWithDifferentIp
} from "./InternetAccessRequestExceptionHandle";
import {setJWT} from "../store/FlightStore";
import VerifyTypeEnum from "../enum/VerifyTypeEnum";
import verifyTypeEnum from "../enum/VerifyTypeEnum";
import {data} from "../example/loginSeat";
import {dataNonQuota} from "../example/loginSeatNonQuota";

export default class LoginStateManager {

    user = null;
    setUser = null;
    setLoading = null;
    navigate = null;
    t = null;
    verifyType = false;
    setDialogDynamic = null

    constructor(props, verifyType) {
        this.user = props.user;
        this.setUser = props.setUser;
        this.setLoading = props.setLoading;
        this.navigate = props.navigate;
        this.t = props.t;
        this.verifyType = verifyType;
        this.setDialogDynamic = props.setDialogDynamic;
    }

    setSimpleUserInfo = (res) => {
        this.setUser({
            ...this.user,
            name: res.name,
            verifyType: verifyTypeEnum.OTHER_LOGIN,
            quotas: {
                nonPurchase: [{
                    "id": 322,
                    "quotaType": "VOLUME",
                    "packageType": "INTERNET",
                    "amount": 1320,
                    "isUnlimited": true,
                    "unit": "MINUTES",
                    "purchaseInfo": null,
                    "isFavor": false,
                    "info_tr": "Sınırsız Chat Paketi (Whatsapp, Telegram)",
                    "info_en": "Unlimited Chat Pckage (Whatsapp, Telegram)",
                    "info_desc_tr": "Sınırsız Chat Paketi (Whatsapp, Telegram)",
                    "info_desc_en": "Unlimited Chat Pckage (Whatsapp, Telegram)"
                }]
            },
            business: false,
            verifiedTripData: {registerCode: null}
        });
    }

    setUserInfoSeat = (data) => {
        this.setUser({
            ...this.user,
            business: data.cabinType === 'C',
            internetAccessRequest: data.internetAccessResponse,
            quotas: this.setQuotas(data),
            totalMiles: data.totalMiles,
            name: data.name,
            surname: data.surname,
            memberId: this.getMemberId(data.memberID),
            package: getUserPackage(data.memberType),
            verifyType: this.getVerifyType(data),
            seatNumber: data.seatNumber,
            tcIdentity: data.tcIdentity,
            email: data.email,
            passportNumber: data.passportNumber
        });
    }

    setQuotas = (data) => {
        if (data.quotas === null) {
            return {"purchase": [], "nonPurchase": [], "favor": []};
        }
        return data.quotas?.quotaResult;
    }

    setUserAddQuotas = (quotas, totalMiles) => {
        this.setUser({
            ...this.user,
            quotas: quotas,
            totalMiles: totalMiles,
        });
    }

    getMemberId = (memberId) => {
        if (memberId !== null && memberId.indexOf('TK') >= 0) {
            return memberId;
        }
        return null;
    }

    getVerifyType = (data) => {
        if (this.verifyType === null) {
            if (data.loginMethod === 'SEATSURNAME_ETICKET') return VerifyTypeEnum.SEAT_OR_TICKET;
            else if (data.loginMethod === 'MSLOGIN') return VerifyTypeEnum.MILES_A_SMILES;
            else if (data.loginMethod === 'SCRATCH_CARD') return VerifyTypeEnum.OTHER_LOGIN;
            else if (data.loginMethod === 'PROMOTION_CODE') return VerifyTypeEnum.OTHER_LOGIN;
            else return VerifyTypeEnum.SEAT_OR_TICKET;
        } else return this.verifyType;
    }

    dialogShow = (isPromotionCode, res) => {
        this.setDialogDynamic({
            visible: true,
            icon: ICON_TYPE.ERROR,
            title: this.getPromotionCodeMessage(isPromotionCode, res),
            content: this.t('error.passenger_not_found'),
            confirm: {
                label: this.t('error.try_again'), click: (setState) => {
                    setState({visible: false});
                }
            },
        });
    }

    redirect = () => {
        this.navigate("/remaining-usage")
    }

    processLoginMilesAndSmiles1 = (memberId, passcode) => {
        if (memberId === 'TK123456789' && passcode === "111111") {
            this.sendProcessLogin(data);
        } else {
            this.dialogShow(false, null);
        }
    }

    processLoginMilesAndSmiles2 = (tcknId, passcode) => {
        if (tcknId === '12322211100' && passcode === "111111") {
            this.sendProcessLogin(data);
        } else {
            this.dialogShow(false, null);
        }
    }

    processLoginMilesAndSmiles3 = (email, passcode) => {
        console.log(email)
        if (email === 'deneme@test.com' && passcode === "111111") {
            this.sendProcessLogin(data);
        } else {
            this.dialogShow(false, null);
        }
    }

    processLoginMilesAndSmiles4 = (phone, passcode) => {
        if (phone === '905551239900' && passcode === "111111") {
            this.sendProcessLogin(data);
        } else {
            this.dialogShow(false, null);
        }
    }

    processForgotPassword = (memberId, seat, ticket) => {
        if (memberId === 'TK123456789' && (seat === "1A" || seat === "01A")) {
            this.sendProcessLogin(data);
        } else if (memberId === 'TK123456789' && (ticket === '1234567890123')) {
            this.sendProcessLogin(data);
        } else {
            this.dialogShow(false, null);
        }
    }

    processLogin = (surname, seat) => {
        if (surname === 'AHMAD' && (seat === "1A" || seat === "01A")) {
            this.sendProcessLogin(data);
        } else if (surname === 'DENEME' && (seat === "2A" || seat === "02A")) {
            this.sendProcessLogin(dataNonQuota);
        } else {
            this.dialogShow(false, null);
        }
    }

    processLoginTicket = (ticket) => {
        if (ticket === '1234567890123') {
            this.sendProcessLogin(data);
        } else {
            this.dialogShow(false, null);
        }
    }

    sendProcessLogin = (data) => {
        let res = data;
        let checkInternetAccess = 0;
        if (!res.error) {
            checkInternetAccess = this.checkInternetAccessResponse(res.data);
        }
        if (res.error) {
            this.dialogShow(this.isExceptionCheckPromotionCode(res.data), null);
        } else if (checkInternetAccess === 1) {
            dialogMaxConcurrentSessionLimitIsReached(this.setDialogDynamic, this.t, res.data, undefined, this.setLoading);
        } else if (checkInternetAccess === 2) {
            dialogUserIdExistsWithDifferentIp(this.setDialogDynamic, this.t);
        } else if (checkInternetAccess === 3) {
            againRequestAccessInternetPopup(this.setDialogDynamic, this.t);
        } else if (checkInternetAccess === 9) {
            dialogInternetAccessProblem(this.setDialogDynamic, this.t, undefined);
        } else {
            setJWT(res.data.jwt);
            this.setUserInfoSeat(res.data);
            this.redirect();
        }
    }

    isExceptionCheckPromotionCode = (data) => {
        let status = false;
        if (data !== undefined)
            data.messageList?.forEach(mess => {
                if (mess.reason != null && mess.reason.includes('internetAccessRequestPC')) status = true;
            })
        return status;
    }

    getExceptionCheckPromotionCode = (data) => {
        let status = "";
        if (data !== undefined)
            data.messageList?.forEach(mess => {
                status = status + mess.localizedDescription + "(" + mess.messageCode + "), "
            })
        if (status !== "")
            status = status.substring(0, status.length - 2);
        return status;
    }

    loginOther2 = (username, password) => {
        if (username === "Deneme" && password === "123456")
            this.sendLoginOther(false)
        else {
            let res = data;
            this.dialogShow(false, res);
        }
    }

    loginOther = (seatNumber, surname, ticketNumber, giftCouponCode, isPromotion) => {
        if (seatNumber === "1A" && surname === "DENEME" && giftCouponCode === "123456")
            this.sendLoginOther(isPromotion)
        else if (ticketNumber === "1234567890123" && giftCouponCode === "123456")
            this.sendLoginOther(isPromotion)
        else {
            let res = data;
            if (isPromotion) this.dialogShow(true, res);
            else dialogScratchCardLoginFailed(this.setDialogDynamic, this.t);
        }
    }

    sendLoginOther = (isPromotion) => {
        let res = data;
        if (!res.error && res.data?.responseHeader?.statusCode === 'SUCCESS') {
            restartWarningDialogPleaseCheckYourDataUsage();
            setJWT(res.data.jwt);
            this.setSimpleUserInfo(res.data);
            this.redirect();
        } else {
            if (isPromotion) this.dialogShow(true, res);
            else dialogScratchCardLoginFailed(this.setDialogDynamic, this.t);
        }
    }

    getPromotionCodeMessage = (isPromotionCode, res) => {
        let rTitle = this.t('error.user_not_found');
        if (isPromotionCode) {
            if (res !== null && res.data?.messageList !== undefined && res.data?.messageList !== null && res.data?.messageList[0] !== undefined) {
                let promotionMessage = res.data?.messageList[0]?.messageCode;
                rTitle = this.t('promotion_code_errors.000');
                if (promotionMessage !== undefined && promotionMessage !== null) {
                    if (promotionMessage === 'APIGW-ERR-CDS-003' || promotionMessage === 'APIGW-ERR-IFC-004' ||
                        promotionMessage === 'APIGW-ERR-CDS-005' || promotionMessage === 'APIGW-ERR-CDS-006')
                        rTitle = this.t('promotion_code_errors.' + promotionMessage);
                }
            } else rTitle = this.t('promotion_code_errors.000');
        }
        return rTitle;
    }

    checkInternetAccessResponse = (data) => {
        let result = data.internetAccessResponse;
        if (result === undefined || result === null || result.length === 0)
            return 0;
        let status = 9;
        for (let i = 0; i < result.length; i++) {
            status = getInternetAccessResponse(result[i]?.respCode);
            if (status !== 0) break;
        }
        return status;
    }

    firstCheckLogin = (res) => {
        if (res === undefined) return;
        let status = res.loginMethod;
        let checkInternetAccess = this.checkInternetAccessResponse(res);
        res.internetAccessResponse = checkInternetAccess;
        if (checkInternetAccess === 1) {
            dialogMaxConcurrentSessionLimitIsReached(this.setDialogDynamic, this.t, res, undefined, this.setLoading);
        } else if (checkInternetAccess === 2) {
            dialogUserIdExistsWithDifferentIp(this.setDialogDynamic, this.t);
        } else if (checkInternetAccess === 3) {
            againRequestAccessInternetPopup(this.setDialogDynamic, this.t);
        } else if (checkInternetAccess === 9) {
            dialogInternetAccessProblem(this.setDialogDynamic, this.t, this.navigate);
        } else {
            // restartWarningDialogPleaseCheckYourDataUsage();
            setJWT(res.jwt);
            this.setUserInfoSeat(res);
            if (status === 'SEATSURNAME_ETICKET' || status === 'MSLOGIN')
                this.redirect();
            else if (status === 'SCRATCH_CARD' || status === 'PROMOTION_CODE') {
                this.setSimpleUserInfo(res);
                this.redirect();
            }
        }
    }

}

